import { toastService } from '@thefarmersfront/kitchen';

import { registerMockAPI } from '~/mocks/mockApis';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { TOAST_MESSAGE } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOwnerSupplierShippingParams } from '~/types/vender.types';

const usePostOwnerSupplierShipping = () => {
  const { runAsync } = useAsyncHandler();

  const postOwnerSupplierShipping = useAPI<TypePostOwnerSupplierShippingParams>({
    endpoint: '/api-owner/owner-supplier',
    method: 'post',
  });

  const registerOwnerSupplierShipping = async (
    { ownerSupplierCode, params }: { ownerSupplierCode: string; params: TypePostOwnerSupplierShippingParams },
    { onSuccess, onError }: { onSuccess?: () => void; onError?: () => void } = {}
  ) => {
    runAsync(() => postOwnerSupplierShipping({ params, pathParams: `/${ownerSupplierCode}/shipping` }), {
      onSuccess,
      onError: (error) => {
        toastService.addToast({
          type: 'error',
          message: (error as TypeErrorResponseData['error'])?.message || TOAST_MESSAGE.DEFAULT_ERROR,
        });
        onError?.();
      },
    });
  };

  return { registerOwnerSupplierShipping };
};

export default usePostOwnerSupplierShipping;

registerMockAPI<null>({
  method: 'post',
  endpoint: '/api-owner/owner-supplier/:ownerSupplierCode/shipping',
  label: '입고/입고요청/출고지등록',
  scenarios: [
    { name: '정상 응답', response: null },
    {
      name: '서버 오류',
      response: { error: { message: '출고지 등록 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
